import { useSelector } from 'react-redux'

import {
  selectDashboardExample,
  selectDashboardExamples,
  selectDashboardExamplesFetchStatus,
  selectDashboardExamplesNrOfCustomers
} from 'redux/selectors/DashboardExamples'
import { ApplicationState } from 'redux/Stores/types'

export const useDashboardExamples = () => useSelector(selectDashboardExamples)

export const useDashboardExample = (id: string) => {
  return useSelector((state: ApplicationState) =>
    selectDashboardExample(state, id)
  )
}

export const useDashboardExamplesFetchStatus = () =>
  useSelector(selectDashboardExamplesFetchStatus)

export const useDashboardExamplesNrOfCustomers = () =>
  useSelector(selectDashboardExamplesNrOfCustomers)
